/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react';
import {ContentHeader} from '@components';
import {Button, Tabs, Tab, Card} from 'react-bootstrap';
import * as AuthService from '../../services/auth';
import { toast } from 'react-toastify';
import TableGroup from '../car/report/TableGroup';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {logoutUser} from '@store/reducers/auth';

const TrainingPermission = () => {
  const [key, setKey] = useState('group');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    downloadHrdWs();
  }, []);

  const [show, setShow] = useState(false);

  const downloadHrdWs = async () => {
    try {
      const show = await AuthService.downloadHrdAdminWs();
      console.log(show);
      if (show.error) throw 'timeout';
      setShow(show.value);
    } catch (error) {
      dispatch(logoutUser());
      navigate('/login');
      window.location.href = '/login';
    }
  };

  return (
    <div>
      <ContentHeader title="HRD" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k : any) => setKey(k)}
                className="mb-3"
              >
                <Tab eventKey="group" title="กลุ่ม">
                  <TableGroup show={show} group_id={["4","5"]} title={"HRD"}></TableGroup>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrainingPermission;
